import { createFileRoute } from '@tanstack/react-router'
import { TicketCreatePage } from '@/features/tickets/create'

export const Route = createFileRoute('/tickets_/new')({
  component: TicketCreatePage,
})
